import React, { useState, useEffect } from "react"

import {
  Card,
  CardBody,
  Col,
  Row,
  CardTitle,
  Alert,
  Label,
  Input,
  Button,
  Modal,
  ModalBody
} from "reactstrap"

import { AvForm, AvField } from "availity-reactstrap-validation"
import { post, put, get } from '../../helpers/api_helper';
import Utils from '../Utility';
import Multiselect from 'multiselect-react-dropdown';
import AddUserForm from './AddUserForm';
import { toast } from 'react-toastify';

const AddLeadForm = (props) => {
  const { user, data, role, loading, setLoading } = props;
  const [successMsg, setSuccessMsg] = useState(null);
  const [errorMsg, setErrorMsg] = useState(null);
  const [descLength, setDescLength] = useState(data ? data?.intro.length : 0);
  const [projects, setProjects] = useState([]);
  const [isModerError, setIsModerError] = useState(false);
  const [isDealerError, setIsDealerError] = useState(false);
  const [dealerOptions, setDealerOptions] = useState([]);
  const [selectedDealer, setSelectedDealer] = useState([]);
  const [moderatorOptions, setModeratorOption] = useState([]);
  const [selectedModer, setSelectedModer] = useState([]);
  const [isUserAdding, setIsUserAdding] = useState(false);
  const [addingUserRole, setAddingUserRole] = useState('Moderator');
  const [currentProject, setCurrentProject] = useState(null);


  useEffect(() => {
    if (props.user) {
      getProjects();
      console.log('data on add lead form', data);
      let temp = [], selected = [], moders = [], selectedMod = [];
      user?.dealer?.map((item) => {
        temp.push({ name: item?.name, id: item?._id });
        if (data) {
          data?.dealers?.map((user) => {
            if (user == item?._id)
              selected.push({ name: item?.name, id: item?._id });
          });
          setSelectedDealer(selected);
        }
      });
      setDealerOptions(temp);
      user?.moderator?.map((item) => {
        moders.push({ name: item?.name, id: item?._id });
        if (data) {
          data?.moderator?.map((user) => {
            if (user == item?._id)
              selectedMod.push({ name: item?.name, id: item?._id });
          });
          setSelectedModer(moders);
        }
      });
      setModeratorOption(moders);
    }
  }, [props.user]);

  const getProjects = () => {
    if (user?.companyId) {
      get("/project/list?companyId=" + user?.companyId, { token: user?.token })
        .then(json => {
          // console.log('response from get project list', json);
          json.data.map((item) => {
            console.log('response from get project list', item?._id);
            if(currentProject?._id==item?._id){
              console.log('found selected project', item?._id);
              setCurrentProject(item);
            }
          })
          setProjects(json?.data);
        })
        .catch(error => {
          console.log('error while getting user list', error);
        });
    } else {
      setErrorMsg("Ask your Admin to create a project first!");
    }
  }

  function handleValidSubmit(event, values) {
    // console.log('values from form', values);
    if (user?.companyId) {
      if (data) {
        //updating user
        const body = {
          ...values,
          token: user?.token,
          lead_id: data?._id,
          companyId: user?.companyId
        };
        setLoading(true);
        let url = "/lead/update";
        put(url, body)
          .then((json) => {
            console.log('response from updating lead', json);
            setLoading(false);
            if (json.statusCode == 200) {
              setSuccessMsg(json?.message);
              setErrorMsg(null);
              props.close(false);
            } else {
              setErrorMsg(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding lead', error);
            setErrorMsg('Something Went Wrong!');
            setSuccessMsg(null);
            setLoading(false);
          })
      } else {
        //adding new user
        if (currentProject?.moderator?.length < 1 && currentProject?.assignType == 'moderator') {
          setAddingUserRole('Moderator')
          setIsUserAdding(true);
          return;
        }
        if (currentProject?.dealers?.length < 1) {
          setAddingUserRole('Dealer')
          setIsUserAdding(true);
          return;
        }
        let dealers = [];
        selectedDealer?.map((item) => {
          dealers.push(item?.id);
        });
        let moder = [];
        selectedModer?.map((item) => {
          moder.push(item?.id);
        });
        const body = {
          ...values,
          dealers,
          moderator: moder,
          addedBy: user?._id,
          token: user?.token,
          companyId: user?.companyId
        };
        let url = "/lead/add";
        setLoading(true);
        post(url, body)
          .then((json) => {
            console.log('response from adding lead', json);
            setLoading(false);
            if (json.statusCode == 200) {
              toast.success(json?.message);
              setErrorMsg(null);
              props.close(false);
            } else {
              toast.error(json?.error);
              setSuccessMsg(null);
            }
          })
          .catch(error => {
            console.error('error while adding lead', error);
            setErrorMsg('Something Went Wrong!');
            setSuccessMsg(null);
            setLoading(false);
          })
      }
    }
  }

  const onSelect = (selectedList, selectedItem, to) => {
    console.log('on select ', selectedList, selectedItem);
    if (to == 'mode') {
      setSelectedDealer(selectedList);
      if (selectedList?.length > 0)
        setIsDealerError(false);
    } else {
      setSelectedModer(selectedList);
      if (selectedList?.length > 0)
        setIsModerError(false);
    }
  }

  const onRemove = (selectedList, removedItem, to) => {
    console.log('remove item', selectedList, removedItem);
    if (to == 'mode') {
      setSelectedDealer(selectedList);
      if (selectedList?.length < 1)
        setIsDealerError(true);
    } else {
      setSelectedModer(selectedList);
      if (selectedList?.length < 1)
        setIsModerError(true);
    }
  }

  const handleProjectChange = (projectId) => {
    const foundProj = projects.find(x => x._id == projectId);
    console.log('selected project', foundProj);
    setCurrentProject(foundProj);
  }

  return (
    <React.Fragment>
      <div className="">
        <Row>
          <Col>
            {errorMsg &&
              <Alert color="danger">{errorMsg}</Alert>
            }
            {successMsg &&
              <Alert color="success">{successMsg}</Alert>
            }
            <Modal isOpen={isUserAdding} toggle={() => setIsUserAdding(false)} centered={true}>
              <ModalBody className="py-3 px-5">
                <AddUserForm
                  role={addingUserRole}
                  close={setIsUserAdding}
                  user={user}
                  loading={loading}
                  setLoading={setLoading}
                  setCurrentUser={() => console.log('setcurrent user to null')}
                  getProfile={props?.getProfile}
                  type={'lead'}
                  project={currentProject}
                  getProjects={getProjects}
                />
              </ModalBody>
            </Modal>
            <Card>
              <CardBody>
                <div className="">
                  <div className="d-flex" style={{ marginLeft: 'auto' }}>
                    <div>
                      <CardTitle className="h4">{data ? 'Update' : 'Add New'} Lead</CardTitle>
                      <p className="card-title-desc">
                        This <code>Lead</code> Will be {data ? 'updated' : 'added'} to your project and can be managed by assigned <code>Moderator and Dealer</code>.
                      </p>
                    </div>
                    <div className="text-center" style={{ marginLeft: 'auto' }}>
                      <Button color="primary" onClick={() => { props.setCurrentUser(null); props?.close(false) }} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                        Close
                      </Button>
                    </div>
                  </div>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleValidSubmit(e, v)
                    }}
                  >
                    <div className="form-group mb-4">
                      <AvField
                        name="projectId"
                        label={"Select Project"}
                        value={data?.projectId}
                        className="form-control"
                        placeholder={`Select project`}
                        type="select"
                        onChange={(e) => handleProjectChange(e.target.value)}
                        required
                      >
                        <option value={""} >Select Project</option>
                        {projects.map(item => (
                          <option value={item?._id} key={item?._id} >{item.name}</option>
                        ))}
                      </AvField>
                    </div>
                    {/* {user?.moderator?.length > 0 &&
                      <>
                        <div className='d-flex'>
                          <span style={{ color: isModerError ? '#ff715b' : '#626c76' }}>Moderators</span>
                          <span style={{ color: 'blue', marginLeft: 10 }}>Node: Moderators will work for all the leads belongs to selected project.</span>
                        </div>
                        <div className={`form-group mb-4 mt-2`}>
                          <Multiselect
                            style={{
                              searchBox: {
                                border: isModerError ? '1px solid #ff715b' : ''
                              }
                            }}
                            options={moderatorOptions} // Options to display in the dropdown
                            selectedValues={selectedModer} // Preselected value to persist in dropdown
                            onSelect={(list, item) => onSelect(list, item, 'mode')}   // Function will trigger on select event
                            onRemove={(list, item) => onRemove(list, item, 'mode')} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            placeholder={"Select Moderator"}
                            showCheckbox
                            name="moderator"
                            label={"Moderator"}
                          />
                          {isModerError &&
                            <span style={{ color: '#ff715b', fontSize: 12 }}>This field is invalid</span>
                          }
                        </div>
                      </>
                    }
                    {user?.dealer?.length > 0 &&
                      <>
                        <div className='d-flex'>
                          <span style={{ color: isModerError ? '#ff715b' : '#626c76' }}>Channel Partners</span>
                          <span style={{ color: 'blue', marginLeft: 10 }}>Node: Channel Partners will work for all the leads belongs to selected project.</span>
                        </div>
                        <div className={`form-group mb-4 mt-2`}>
                          <Multiselect
                            style={{
                              searchBox: {
                                border: isDealerError ? '1px solid #ff715b' : ''
                              }
                            }}
                            options={dealerOptions} // Options to display in the dropdown
                            selectedValues={selectedDealer} // Preselected value to persist in dropdown
                            onSelect={(list, item) => onSelect(list, item, 'deal')}   // Function will trigger on select event
                            onRemove={(list, item) => onRemove(list, item, 'deal')} // Function will trigger on remove event
                            displayValue="name" // Property name to display in the dropdown options
                            placeholder={"Select Channel Partners"}
                            showCheckbox
                            name="dealers"
                            label={"Channel Partners"}
                          />
                          {isDealerError &&
                            <span style={{ color: '#ff715b', fontSize: 12 }}>This field is invalid</span>
                          }
                        </div>
                      </>
                    } */}
                    <div className="form-group mb-4">
                      <AvField
                        name="name"
                        label={"Title"}
                        value={data?.name}
                        className="form-control"
                        placeholder={`Enter Title`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="clientName"
                        label={"Client Name"}
                        value={data?.clientName}
                        className="form-control"
                        placeholder={`Enter ${props.role}'s Client Name`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="mobile"
                        label={"Client Mobile"}
                        value={data?.mobile}
                        className="form-control"
                        placeholder={`Enter Mobile`}
                        type="text"
                        required
                        validate={{ maxLength: { value: 10 }, minLength: { value: 10 } }}
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="email"
                        label={"Email"}
                        value={data?.email}
                        className="form-control"
                        placeholder={`Enter Email`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="source"
                        label={props.role + " Source"}
                        value={data?.source}
                        className="form-control"
                        placeholder={`Enter ${props.role} Source/Medium`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="address"
                        label={"Address"}
                        value={data?.address}
                        className="form-control"
                        placeholder={`Enter Address`}
                        type="text"
                        required
                      />
                    </div>
                    <div className="form-group mb-4">
                      <AvField
                        name="intro"
                        label={"Description"}
                        value={data?.intro}
                        className="form-control"
                        placeholder={`Enter Description`}
                        type="textarea"
                        required
                        validate={{ maxLength: { value: 200 } }}
                        onChange={(t) => setDescLength(t.target.value.length)}
                      />
                    </div>
                    <div className="mt-3" style={{ textAlign: 'end' }}>
                      <p>{descLength}/200</p>
                    </div>
                    {/* <AvField name="idx" value={user?.company._id} type="hidden" /> */}
                    <div className="text-center mt-4">
                      {data ?
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Update {props.role}
                        </Button>
                        :
                        <Button type="submit" color="primary" style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor }}>
                          Add {props.role}
                        </Button>
                      }
                    </div>
                  </AvForm>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}

export default AddLeadForm;
